import Pusher from 'pusher-js'

const vuePusher = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
  cluster: import.meta.env.VITE_PUSHER_CLUSTER,
})

export default vuePusher
